<template>
    <div class="qksm qksm5">
        <h4>五、一般公共预算财政拨款支出情况说明</h4>
        <div class="nogap">
            <p><b>（一）一般公共预算支出总体情况。</b></p>
            <p>
                2020年度一般公共预算支出{{isMoney(T5.总计)}}万元，占本年支出合计的{{calcRatio(T5.总计,T3.总计)}}。
                <span class="hide_pdf">
                    （上年决算数<reason type="money" classname="qksm money nullable" name="公共预算支出去年" v-model:value="T5.总计_last"></reason>万元）
                </span>
                较上年{{growthValueText(T5.总计,T5.总计_last)}}万元，{{growthRatioText(T5.总计,T5.总计_last)}}。
                主要原因是<reason type="textarea" classname="qksm widest" name="公共预算支出原因" v-model:value="qksm['公共预算支出原因']"></reason>
            </p>
        </div>
        <div id="myChart5" class="echart" v-if="!isPdf && $parent.isData"></div>
        <div id="myChart5" class="echart" v-if="isPdf"></div>
        <div class="nogap">
            <p><b>（二）一般公共预算支出结构情况。</b></p>
            <p>
                2020年度一般公共预算支出主要用于以下方面：
                <span v-for="(item,idx) in T5.items">
                    {{item.name}}（类）{{isMoney(item.value)}}万元，占{{getPercentValue(T5.items.map(e=>e.value), idx, 2)}}{{idx==T5.items.length-1?'。':'；'}}
                </span>
            </p>
            <p><b>（三）一般公共预算支出具体情况。</b></p>
            <p>
                2020年度一般公共预算支出年初预算为
                <reason type="money" classname="qksm money " name="公共预算支出预算" v-model:value="qksm['公共预算支出预算']"></reason>万元，
                支出决算为{{isMoney(T5.总计)}}万元，
                <template v-if="num(qksm['公共预算支出预算'])==num(T5.总计)">
                    完成年初预算的100%。
                </template>
                <template v-else>
                    <template v-if="num(qksm['公共预算支出预算'])==0">
                        年初无预算。
                    </template>
                    <template v-else>
                        完成年初预算的{{calcRatio(T5.总计,qksm['公共预算支出预算'])}}。
                    </template>
                    决算数{{num(T5.总计)>num(qksm['公共预算支出预算']) ? "大于" : "小于"}}预算数的主要原因是
                    <reason type="textarea" classname="qksm widest" name="预算支出比率原因" v-model:value="qksm['预算支出比率原因']"></reason>
                </template>
                其中：
            </p>
            <template v-for="(item,idx) in items">
                <p>{{items.length>1 ? idx+1+". " :""}}{{item.lei}}</p>
                <p v-if="item.kuan.length==0">
                    {{item.lei}}。年初预算为
                    <reason type="money" classname="qksm money" :name="item.code+'预算'" v-model:value="qksm[item.code+'预算']"></reason>万元，支出决算为{{isMoney(item.value)}}万元，
                    <template v-if="num(qksm[item.code+'预算'])==num(item.value)">
                        完成年初预算的100%。
                    </template>
                    <template v-else>
                        <template v-if="num(qksm[item.code+'预算'])==0">
                            年初无预算。
                        </template>
                        <template v-else>
                            完成年初预算的{{calcRatio(item.value,qksm[item.code+'预算'])}}。
                        </template>
                        决算数{{num(item.value)>num(qksm[item.code+'预算']) ? "大于" : "小于"}}预算数的主要原因
                        <reason type="textarea" classname="qksm widest" :name="item.code+'原因'" v-model:value="qksm[item.code+'原因']"></reason>
                    </template>
                </p>
                <p v-else v-for="(itemk,idy) in item.kuan">
                    {{item.kuan.length>1 ? "（"+(idy+1)+"）" :""}}{{itemk.kuan}}{{itemk.xiang}}。年初预算为
                    <reason type="money" classname="qksm money" :name="itemk.code+'预算'" v-model:value="qksm[itemk.code+'预算']"></reason>万元，支出决算为{{isMoney(itemk.value)}}万元，
                    <template v-if="num(qksm[itemk.code+'预算'])==num(itemk.value)">
                        完成年初预算的100%。
                    </template>
                    <template v-else>
                        <template v-if="num(qksm[itemk.code+'预算'])==0">
                            年初无预算。
                        </template>
                        <template v-else>
                            完成年初预算的{{calcRatio(itemk.value,qksm[itemk.code+'预算'])}}。
                        </template>
                        决算数{{num(itemk.value)>num(qksm[itemk.code+'预算']) ? "大于" : "小于"}}预算数的主要原因
                        <reason type="textarea" classname="qksm widest" :name="itemk.code+'原因'" v-model:value="qksm[itemk.code+'原因']"></reason>
                    </template>
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        props: {
            T3: {
                type: Object,
                default: "",
            },
            T5: {
                type: Object,
                default: "",
            },
        },
        created() {
            var arr = [];
            this.T5.items.map(a => {
                var arrKuan = [];
                a.children.map(b => {
                    if (b.children.length == 0) {
                        this.qksm[b.code + '预算'] = this.pickOneOf(this.qksm[b.code + '预算'], b.value_ys)
                        arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: "", code: b.code, value: this.isMoney(b.value), })
                    } else {
                        b.children.map(c => {
                            this.qksm[c.code + '预算'] = this.pickOneOf(this.qksm[c.code + '预算'], c.value_ys)
                            arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: c.name + "（项）", code: c.code, value: this.isMoney(c.value), })
                        })
                    }
                })
                arr.push({ lei: a.name + "（类）", code: a.code, value: this.isMoney(a.value), kuan: arrKuan })
            })
            this.items = arr
            this.inspect()
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            qksm['公共预算支出预算'] = this.pickOneOf(qksm['公共预算支出预算'], this.T5.总计_ys)
            qksm['预算支出比率原因'] = this.pickOneOf(qksm['预算支出比率原因'], qksm['公共预算支出原因'])
            if (qksm['公共预算支出去年'])
                this.T5['总计_last'] = qksm['公共预算支出去年'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },
        computed: {
            总计_last() {
                return this.isMoney(this.T5.总计_last)
            }
        },
        watch: {
            总计_last() {
                this.$parent.isChart()
            }
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var arr = []
                this.items.forEach(function (row) {
                    if (row.kuan) {
                        row.kuan.forEach(function (row) {
                            arr.push({ "code": row.code, "value": row.value })
                        })
                    } else {
                        arr.push({ "code": row.code, "value": row.value })
                    }
                })
                var sum = 0;
                for (var i = 0; i < arr.length; i++) {
                    sum = sum + this.num(this.qksm[arr[i].code + '预算'])
                }
                if (this.num(this.qksm['公共预算支出预算']).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm5", "请检查本页《五、一般公共预算财政拨款支出情况说明（三）一般公共预算支出具体情况》，各分项年初预算数的合计金额与一般公共预算支出年初预算总额不等。");
                } else {
                    this.remove("qksm5")
                }
            }
        }

    };
</script>
